import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button, CircularProgress, Container, Typography, TextField } from '@mui/material';

// Alerts
import { setError, setSuccess } from '../../../../alerts';

// Images
import ColorLogo from '../../../../images/ColorLogo.png';

// API
import { requestForgotPassword } from '../../../../api';

// Constants
import { NAVY } from '../../../../constants';

class ForgotPasswordRequest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      redirect: false,
      isLoading: false
    };
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const { email } = this.state;

    this.setState({ isLoading: true });
    requestForgotPassword(email).then(() => {
      setSuccess('Successfully sent forgot password link to your email, if your account exists.');
      this.setState({ isLoading: false, redirect: true });
    }).catch(error => {
      setError(error ? error : 'Error: Unable to send forgot password request.');
      this.setState({ isLoading: false });
    });
  };

  render() {
    return this.state.redirect ? <Redirect to='/auth/login' /> : (
      <Container>
        <form autoComplete="off" onSubmit={this.onSubmit} style={{ marginBottom: '5em' }}>
          {/* ----- LOGO & TITLE ----- */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '2em', marginBottom: '1em' }}>
            <img
              width={250}
              src={ColorLogo}
              alt={'Logo'}
              title={'Logo'}
              style={{ objectFit: 'contain' }}
            />
          </div>
          <Typography variant='h1' style={{ textAlign: 'center', marginBottom: '1em' }}>Forgot Password</Typography>

          {/* Email Input */}
          <TextField
            required
            error={this.state.formError && this.state.email === ''}
            name="email"
            label="Email"
            type='email'
            style={{ width: '100%', marginBottom: '10px' }}
            value={this.state.email}
            onChange={this.onChange}
            variant='filled'
          />

          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '40px' }}>
            <Button type='submit' variant='contained' disabled={this.state.isLoading} style={{ width: '50%', backgroundColor: NAVY, color: 'white' }}>
              Submit
              {this.state.isLoading && <CircularProgress size={25} style={{ marginLeft: '1em' }} />}
            </Button>

            <Typography variant='button' style={{ marginTop: '10px' }}>Know your password?{' '}
              <Link to='/auth/login' style={{ color: NAVY }}>
                Login now
              </Link>.
            </Typography>
          </div>
        </form>
      </Container>
    );
  }
}

export default ForgotPasswordRequest;
